const state = {
  accounts: [],
  selectedUserAccount: null,
};

const getters = {
  userAccounts: (state) => state.accounts,
  selectedUserAccount: (state) => state.selectedUserAccount,
};

const actions = {
  async fetchCustomerAccounts({ commit }, { msp_id = null }) {
    const response = await this._vm.$http.get(
      msp_id != null ? `/restapi/users/?msp_id=${msp_id}` : `/restapi/users/`
    );
    commit("setAccounts", response.data);
  },

  async fetchCustomerAccount({ commit, state }, { id }) {
    const response = await this._vm.$http.get(`/restapi/users/${id}`);
    const index = state.accounts.findIndex(
      (account) => account.id === response.data.id
    );
    if (index === -1) {
      commit("addAccount", response.data);
    } else {
      commit("updateAccount", { idx: index, account: response.data });
    }
    commit("setselectedUserAccount", response.data);
  },

  async createCustomerAccount({ commit }, { customer }) {
    const response = await this._vm.$http.post("/restapi/users/", customer);
    commit("addAccount", response.data);
    return response.data;
  },

  async updateCustomerAccount({ commit }, { id, customer }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}`,
      customer
    );
    commit("updateAccount", response.data);
    commit("setselectedUserAccount", response.data);
  },

  async updateCustomerPassword({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/auth/password`, body);
    commit("updateAccount", response.data);
    return response.data;
  },

  async deleteCustomerAccounts({ commit }, users) {
    const req = {};

    for (const user of users) {
      req[`${user.id}`] = {
        method: "delete",
        path: `users/${user.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteAccount", ids);
  },

  async regenerateUserOTGKey({ dispatch }, { id }) {
    await this._vm.$http.put(`/restapi/users/${id}/devices/key`);

    await dispatch("fetchCustomerAccount", { id });
  },

  // eslint-disable-next-line no-unused-vars
  async logoutUser({ dispatch }) {
    await this._vm.$http.post(`/restapi/auth/logout`);
  },
};

const mutations = {
  setAccounts: (state, data) => (state.accounts = data.data),
  setselectedUserAccount: (state, data) => (state.selectedUserAccount = data),
  addAccount: (state, data) => state.accounts.push(data),
  updateAccount: (state, data) =>
    (state.accounts[`${data.idx}`] = data.account),
  deleteAccount(state, users) {
    for (const user of users) {
      state.accounts = state.accounts.filter((account) => account.id !== user);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
